import { getUserId } from "helpers/localstoragehelper";
import { useGetUserQuery } from "reduxStore/api/userApiSlice";

const useUser = () => {
  const { data: userData } = useGetUserQuery(getUserId());

  return userData;
};

export default useUser;
